(() => {
  if (window.nozzleProPageJumpInitialized) return;
  window.nozzleProPageJumpInitialized = true;
  const main = document.getElementById('MainContent');
  if (!main) return;
  let frame;

  const update = () => {
    frame = null;
    const plugin = main.querySelector('#gf_pagination_wrap');
    const hosts = plugin ? [plugin] : [...main.querySelectorAll('#ProductGridContainer .pagination')];
    for (const host of hosts) {
      const links = [...host.querySelectorAll('a[href]')].filter(a => {
        const page = Number(new URL(a.href, location.href).searchParams.get('page'));
        return Number.isInteger(page) && page > 0;
      });
      const current = Number(host.querySelector('.current, .page-number-active')?.textContent.trim()) || 1;
      const pages = Math.max(current, ...links.map(a => Number(new URL(a.href, location.href).searchParams.get('page'))));
      let form = host.querySelector('.np-page-jump');
      if (pages < 2) { form?.remove(); continue; }
      if (!form) {
        host.classList.add('np-page-jump-host');
        form = document.createElement('form');
        form.className = 'np-page-jump';
        form.setAttribute('aria-label', 'Jump to a product page');
        form.innerHTML = '<label class="np-page-jump__label">Go to page <input type="number" min="1" step="1" inputmode="numeric" required aria-label="Page number"></label><span class="np-page-jump__total"></span><button type="submit">Go</button>';
        form.addEventListener('submit', event => {
          event.preventDefault();
          const input = form.querySelector('input');
          if (!form.reportValidity()) return;
          const page = Number(input.value);
          if (!Number.isInteger(page) || page < 1 || page > Number(input.max)) return;
          const url = new URL(location.href);
          url.searchParams.set('page', String(page));
          if (host.id === 'gf_pagination_wrap') {
            // Delegate to Globo's existing .gspf-page click handler, which retains filter state.
            const holder = document.createElement('span');
            holder.className = 'page';
            holder.hidden = true;
            const link = document.createElement('a');
            link.className = 'gspf-page';
            link.dataset.page = String(page);
            link.href = url.href;
            holder.appendChild(link);
            (host.querySelector('#pagination') || host).appendChild(holder);
            link.click();
            holder.remove();
          } else {
            location.assign(url.href);
          }
        });
        host.appendChild(form);
      }
      const input = form.querySelector('input');
      const signature = `${current}/${pages}`;
      if (form.dataset.pagination !== signature) {
        input.max = String(pages);
        input.value = String(current);
        form.querySelector('.np-page-jump__total').textContent = `of ${pages}`;
        form.dataset.pagination = signature;
      }
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const observer = new MutationObserver(schedule);
  observer.observe(main, { childList: true, subtree: true });
  window.addEventListener('globoFilterRenderCompleted', schedule);
  window.addEventListener('popstate', schedule);
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  update();
})();
